export * from "@/utils/capacitor";
export const isOnTest = import.meta.env.VITE_AUTH_ENV === "ontest";
export const isDev = import.meta.env.VITE_NODE_ENV === "development";

export const HUVersion = import.meta.env.VITE_APP_PLATFORM;
export const isSS3 = HUVersion === "ss3";
export const isSS4 = HUVersion === "ss4";
